import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import Select from "react-select";
import { FaShare } from "react-icons/fa";
import { RiRfidLine } from "react-icons/ri";
import {
  AssetAllocateApi,
  AssetSearchAllocationOptionApi,
} from "../../../services/AssetService";
import { toast } from "react-toastify";
import { SearchAreaApi } from "../../../services/SearchService";
import RFIDScannerModal from "../../../components/RFIDControlPanel/RFIDControlPanel";

const AssetAllocateModal = ({
  visible,
  onClose,
  id,
  onAfterSubmit,
  isRfidExist,
}) => {
  const [allocationOption, setAllocateOption] = useState([]);
  const [selectedAllocationOption, setSelcetdAllocationOption] = useState(null);
  const [areaoption, setAreaOption] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [allocationoptionLoading, setAllocationoptionLoading] = useState(false);
  const [areaOptionLoading, setAreaOptionLoading] = useState(false);
  const [rfidScanModal, setRfidScanModal] = useState(false);

  const [form, setForm] = useState({
    allocation_type: "",
    allocation_to: "",
    allocation_area: "",
    remarks: "",
    rfid: "",
  });
  const [error, setError] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);
  useEffect(() => {
    if (visible) {
      handleReset();
    }
  }, [visible]);
  const getAllocationOption = (value) => {
    setAllocationoptionLoading(true);
    AssetSearchAllocationOptionApi({ allocation_type: value })
      .then((res) => {
        setAllocateOption(res?.data?.results || []);
      })
      .catch((err) => {
        toast.err(
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Try again later"
        );
      })
      .finally(() => {
        setAllocationoptionLoading(false);
      });
  };
  const getAreaOption = (data) => {
    setAreaOptionLoading(true);
    SearchAreaApi(data)
      .then((res) => {
        setAreaOption(res?.data?.results || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Try agian later"
        );
      })
      .finally(() => {
        setAreaOptionLoading(false);
      });
  };

  useEffect(() => {
    setForm({
      ...form,
      allocation_area: selectedArea?.value || "",
      allocation_to: selectedAllocationOption?.value || "",
    });
    const err = { ...error };
    if (selectedArea?.value) {
      err.allocation_area = "";
    }
    if (selectedAllocationOption?.value) {
      err.allocation_to = "";
    }
    setError(err);
  }, [selectedArea, selectedAllocationOption]);

  useEffect(() => {
    setSelcetdAllocationOption(null);
    setSelectedArea(null);
    setAllocateOption([]);
    setAreaOption([]);

    setForm((prev) => ({
      ...prev,
      allocation_to: "",
      allocation_area: "",
    }));

    if (form.allocation_type) {
      getAllocationOption(form.allocation_type);
    }
  }, [form.allocation_type]);

  useEffect(() => {
    if (!form.allocation_type || !form.allocation_to) return;

    setSelectedArea(null);
    setAreaOption([]);

    setForm((prev) => ({
      ...prev,
      allocation_area: "",
    }));

    const searchParam =
      form.allocation_type === "DEPARTMENT"
        ? { department: form.allocation_to }
        : { employee: form.allocation_to };

    getAreaOption(searchParam);
  }, [form.allocation_to]);

  const handleReset = () => {
    setSelcetdAllocationOption(null);
    setAllocateOption([]);
    setForm({
      allocation_to: "",
      allocation_type: "",
      allocation_area: "",
      remarks: "",
      rfid: ""
    });
    setError({});
  };

  const handleSubmit = () => {
    let errorObj = {};
    if (!form?.allocation_to) {
      errorObj.allocation_to = "Mandatory Field";
    }
    if (!form?.allocation_type) {
      errorObj.allocation_type = "Mandatory Field";
    }
    if (!form?.allocation_area) {
      errorObj.allocation_area = "Mandatory Field";
    }
    if (!isRfidExist && !form?.rfid) {
      errorObj.rfid = "Mandatory Field";
    }
    setError(errorObj);
    if (Object.keys(errorObj).length === 0) {
      const { rfid, ...rest } = form;
      setSubmitLoading(true);
      AssetAllocateApi(id, isRfidExist ? rest : form)
        .then((res) => {
          const { message, results } = res.data;
          toast.success(message || "Allocate Successfully");
          onAfterSubmit(results);
        })
        .catch((err) => {
          toast.error(
            err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
          );
        })
        .finally(() => {
          setSubmitLoading(false);
        });
    }
  };


  const toggleRfidScanModal = () => setRfidScanModal(!rfidScanModal);

  const handleOnChangeRfid = (tag) => {
    if (tag) {
      setError({ ...error, rfid: "" });
    }
    setForm({ ...form, rfid: tag || "" });
  }

  return (
    <div>
      <Modal show={visible} onHide={onClose}>
        <Modal.Header>
          <Modal.Title className="text-info">
            {" "}
            <FaShare className="me-1" /> Allocate Asset
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row p-2 gy-2">
            {/* Allocation Type */}
            <div className="col-md-6">
              <label className="form-label text-dark mb-1">
                Allocation Type
              </label>
              <div className="d-flex gap-4 align-items-center mt-1">
                {/* Employee */}
                <div className="d-flex align-items-center">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="allocation_type"
                    value="EMPLOYEE"
                    id="allocation_employee"
                    checked={form.allocation_type === "EMPLOYEE"}
                    onChange={(e) => {
                      if (e.target.value) {
                        setError({ ...error, allocation_type: "" });
                      }
                      setForm((prev) => ({
                        ...prev,
                        allocation_type: e.target.value,
                      }));
                    }}
                    style={{ width: "16px", height: "16px", marginTop: "0" }}
                  />
                  <label
                    htmlFor="allocation_employee"
                    className="form-check-label text-dark fw-medium"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Employee
                  </label>
                </div>
                {/* Department */}
                <div className="d-flex align-items-center">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="allocation_type"
                    value="DEPARTMENT"
                    id="allocation_department"
                    checked={form.allocation_type === "DEPARTMENT"}
                    onChange={(e) => {
                      if (e.target.value) {
                        setError({ ...error, allocation_type: "" });
                      }
                      setForm((prev) => ({
                        ...prev,
                        allocation_type: e.target.value,
                      }));
                    }}
                    style={{ width: "16px", height: "16px", marginTop: "0" }}
                  />
                  <label
                    htmlFor="allocation_department"
                    className="form-check-label text-dark fw-medium"
                    style={{ fontSize: "0.85rem" }}
                  >
                    Department
                  </label>
                </div>
              </div>
              {error?.allocation_type && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  {error.allocation_type}
                </div>
              )}
            </div>

            {/* Allocation To */}
            <div className="col-md-6">
              <label className="form-label text-dark mb-1">Allocation To</label>
              <Select
                classNamePrefix="select"
                className="react-select"
                placeholder={`Select ${form?.allocation_type || "Allocating To"
                  }`}
                isLoading={allocationoptionLoading}
                options={allocationOption}
                value={selectedAllocationOption}
                onChange={setSelcetdAllocationOption}
              />
              {error?.allocation_to && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  {error.allocation_to}
                </div>
              )}
            </div>

            {/* Area */}
            <div className="col-12">
              <label className="form-label text-dark mb-1">Area</label>
              <Select
                classNamePrefix="select"
                className="react-select"
                placeholder={`Select Area For ${form?.allocation_type || "Allocating To"
                  }`}
                isLoading={areaOptionLoading}
                options={areaoption}
                value={selectedArea}
                onChange={setSelectedArea}
              />
              {error?.allocation_area && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  {error.allocation_area}
                </div>
              )}
            </div>

            {/* Remark */}
            <div className="col-12">
              <label className="form-label text-dark mb-1">Remark</label>
              <textarea
                className="form-control"
                rows="1"
                placeholder="Optional"
                name="remark"
                value={form?.remarks}
                onChange={(e) =>
                  setForm({ ...form, remarks: e.target.value || "" })
                }
              ></textarea>
            </div>

            {/* RFID */}
            {!isRfidExist && (
              <div>
                <div className="col-12">
                  <label className="form-label text-dark mb-1">
                    RFID Number
                  </label>
                  <div className="position-relative">
                    {/* Search Icon */}
                    <input
                      className={`form-control pe-8 ${error?.rfid ? "is-invalid" : ""
                        }`}
                      placeholder="RFID-123456"
                      name="rfid"
                      style={{ paddingRight: "6rem" }}
                      readOnly
                      value={form.rfid}
                    />
                    <button
                      className="position-absolute top-50 end-0 translate-middle-y me-1 btn btn-sm btn-primary"
                      onClick={toggleRfidScanModal}
                    ><RiRfidLine className="me-1" /> Scan</button>

                  </div>
                  {error?.rfid && (
                    <span className="text-danger small">{error?.rfid}</span>
                  )}
                </div>
                <code className="text-light mt-1">
                  <strong>Note</strong>: Scan a unique RFID tag assigned to
                  this asset by clicking the scan button.
                </code>
              </div>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <span
              className="btn btn-outline-danger"
              disabled={submitLoading}
              onClick={onClose}
            >
              Cancel
            </span>
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={submitLoading}
            >
              {submitLoading && (
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Allocate
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <RFIDScannerModal
        visible={rfidScanModal}
        onClose={() => setRfidScanModal(false)}
        onSuccess={(tag) => handleOnChangeRfid(tag)}
      />
    </div>
  );
};

export default AssetAllocateModal;
